// extracted by mini-css-extract-plugin
export default {"PricesContainer":"Prices_PricesContainer__MCrtf","Prices":"Prices_Prices__BDech","TitleContainer":"Prices_TitleContainer__O04Hj","Subscription":"Prices_Subscription__dHIfz"};